import axios from '../config'
import { marke_api } from '../baseURL'

export default {
  getCards({ studentId, classId, trainId }) {
    if(!trainId) return axios.get(`${marke_api}/card/list?studentId=${studentId}&classId=${classId}`)
    return axios.get(`${marke_api}/card/list?studentId=${studentId}&classId=${classId}&trainId=${trainId}`)
  },
  
  createCard(data) {
    return axios.post(`${marke_api}/card`, data);
  },
  
  updateCard(data) {
    return axios.put(`${marke_api}/card`, data);
  },
  
  updateCards(list) {
    return axios.put(`${marke_api}/card/list`, { list });
  },
  
  deleteCard(id) {
    return axios.delete(`${marke_api}/card/${id}`);
  },
  
  deleteCards(idList) {
    return axios.delete(`${marke_api}/card/list?ids=${idList}`);
  },
}